<template>
    <div class="addressBook">
        <div class="tableComponent">
            <!--:max-height="tableMaxheight"-->
            <el-table lazy
                      ref="eltable" :data="tableData" height="100%" scrollbar-always-on="true"
                      style="width: 100%">
                <el-table-column type="index" align="center" label="序号" width="200" />
                <el-table-column prop="name" label="文件名称" min-width="20%" />
                <el-table-column align="center" header-align="center" width="300">
                    <template
                        slot="header"
                        #header="scope"
                    >
                        <div class="opreate">
                            <span>操作</span>
                        </div>
                    </template>
                    <template #default="scope">
                        <div class="opreateBtns">
                            <div class="addressBook_bjBtn" @click="excelPreview(scope.row)">
                                <img src="../../assets/images/edit-outline@2x.png" alt="">预览
                            </div>
                            <div class="addressBook_bjBtn" @click="extExcel(scope.row)">
                                <img src="../../assets/images/edit-outline@2x.png" alt="">下载
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="jsjb_buttonPage">
            <div class="jsjb_button">
                <!--<div class="jsjb_button_list" @click="extExcel">-->
                    <!--<i class="icon-file-excel"></i>导出Excel-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-file-wordine"></i>导出word-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-liucheng"></i>导出Wrod(流程)-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-alarmClock"></i>催办-->
                <!--</div>-->
            </div>
            <el-pagination
                v-model:page-size="formData.pageSize"
                v-model:current-page="formData.pageNum"
                :page-sizes="[50, 100,150, 200]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rowsCount"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
    import {reactive, computed,onMounted, ref,getCurrentInstance} from 'vue'
    import { Search } from '@element-plus/icons-vue'
    import {filePreviewByUrl} from '../../assets/js/base.js';
    export default {
        name: "FileDownload",
        setup(){
            const {proxy} = getCurrentInstance();
            let tableData = ref()
            let formData = ref({
                search:"",
                "pageNum": 1,
                "pageSize": 12
            })
            let rowsCount = ref(100);
            const tableRequst = ()=>{
                let fileList = [
                    {name:'1.街道乡镇反恐防暴检查单.xlsx'},
                    {name:'2.街道乡镇创城检查单.xlsx'},
                    {name:'3.街道乡镇劳动监察日常执法检查单-工程建设领域.xlsx'},
                    {name:'4.街道乡镇劳动监察日常执法检查单-七小门店及企业类.xlsx'},
                    {name:'5.街道乡镇劳动监察日常执法检查单-用人单位招工情况检查单.xlsx'}
                ]
                tableData.value = fileList;
                rowsCount.value = fileList.length;
            }
            const handleSizeChange =(param)=>{
                tableRequst()
            }
            const handleCurrentChange = (param)=>{
                tableRequst()
            }
            const searchEvent =()=>{
                tableRequst()
            }


            //导出excel
            const excelPreview = (param) => {
                let filename = param.name;
                let url = document.location.origin+'/file/'+filename; //要预览文件的访问地址
                filePreviewByUrl(url,filename,Date.now())
            }
            //导出excel
            const extExcel = (param) => {
                let filename = param.name;
                proxy.$axios.own.get('/file/'+filename,{
                    // params: params,
                    responseType: 'blob'   //首先设置responseType字段格式为 blob
                }).then(res => {
                    let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
                    let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    // 释放这个临时的对象url
                    window.URL.revokeObjectURL(url);
                });
            }

            onMounted(()=>{
                tableRequst();
            })
            return{
                Search,
                rowsCount,
                formData,
                tableData,
                extExcel,
                excelPreview,
                handleSizeChange,
                handleCurrentChange,
                searchEvent
            }
        }
    }
</script>

<style scoped>

</style>
